import React, { useState } from "react";
import {
  ButtonSecondary,
  Label,
  SelectInput,
  TextInput,
} from "../../../../components/globals";
import { CheckBoxInput } from "../../../../components/common/Buttons";
import { useSelector } from "react-redux";
import useFetch from "../../../../hooks/useFetch";
import { useMutation, useQuery } from "react-query";
import AvailableMenu from "./AvailableMenu";
import Spinner from "../../../../components/common/Spinner";
import NewInputSwitchComponent from "../../../../components/common/NewInputSwitchComponent";
import styled from "styled-components";
import ModalSimple from "../../../../components/Layout/Modals/ModalSimple";
import { onChangeUseState } from "../../../../helpers/FunctionsGlobal";
import Axios from "axios";
import {
  IconChevronDown,
  IconChevronUp,
} from "../../../../components/Layout/Icons";
import { antdMessageError } from "../../../../helpers/Utils";
import { colors } from "../../../../utils/colors";
import { getStatusesOptions } from "../../../../redux/Actions/statusesAction";

const ModalUserRoleCreate = ({ user_role_id, setModal }) => {
  const { order_shops } = useSelector((state) => state.options);
  const { loading, value, setValue } = useFetch(
    `/api/v1/user_roles/${user_role_id == 0 ? "new" : user_role_id}`
  );

  const [Open, setOpen] = useState([]);
  const [errors, setErrors] = useState({});

  const { data: statusesOptions = [] } = useQuery({
    queryKey: ["statuses_options"],
    queryFn: getStatusesOptions,
  });

  const menu_tree = AvailableMenu({ id: 1 });

  const mutationCreate = useMutation({
    mutationFn: (value) =>
      Axios({
        url: `/api/v1/user_roles/${value?.id ?? ""}`,
        data: {
          user_roles: { ...value, used: undefined },
        },
        method: value?.id ? "PUT" : "POST",
      }).then((res) => res.data),
    onSuccess: () => {
      setModal(null);
    },
    onError: (error) => antdMessageError(error?.response?.data?.message),
  });

  return (
    <ModalSimple
      text={!!value?.id ? "Update role" : "Create role"}
      hide={true}
      onClose={() => {
        setModal(false);
      }}
    >
      {loading ? (
        <Spinner />
      ) : (
        <div
          className="d-flex flex-column justify-content-between"
          style={{ height: "100%" }}
        >
          <div className="">
            <TextInput
              text="Role title"
              required
              name="title"
              value={value.title}
              onChange={onChangeUseState(setValue)}
              warning={errors.title}
            />
            <div className="my-2" />
            <SelectInput
              label="Role identifier"
              name="identifier"
              value={value.identifier || undefined}
              onChange={(value) =>
                setValue((prev) => ({ ...prev, identifier: value }))
              }
              warning={errors.identifier}
              options={["", "admin", "manager", "accounting", "nordrent"].map((value) => ({
                label: value == "" ? "Empty" : value,
                value,
              }))}
            />
            <div className="my-2" />
            <NewInputSwitchComponent
              showCheckBox={true}
              childrenStyle={{
                width: "49%",
                justifyContent: "start",
                borderRadius: 4,
              }}
              type="multiple"
              label={"Projects"}
              name={"shop_ids"}
              options={order_shops}
              value={value.shop_ids}
              onChange={onChangeUseState(setValue)}
            />
            <div className="my-2" />
            <Label required={true}>Sections</Label>
            {menu_tree.map((e) => (
              <PermissionBlock
                key={e.uuid}
                parent_uuid={e.uuid}
                {...e}
                setOpen={setOpen}
                Open={Open}
                permissions={value.permissions}
                setPermissions={(uid, extras) => {
                  setValue((prev) => {
                    const first_uid = uid[0];
                    const parent_uid = uid[1];
                    const value = !prev["permissions"][first_uid];
                    let extras_obj = {};
                    if (extras && extras.length > 0) {
                      extras.forEach((e) => (extras_obj[e] = value));
                    }
                    if (parent_uid && value) {
                      extras_obj[parent_uid] = true;
                    }
                    return {
                      ...prev,
                      permissions: {
                        ...prev.permissions,
                        ...extras_obj,
                        [first_uid]: value,
                      },
                    };
                  });
                }}
              />
            ))}
          </div>
          <div className="my-2" />
          <SelectInput
            label="Statuses"
            name="status_ids"
            mode="multiple"
            value={value.status_ids || []}
            onChange={(status_ids) =>
              setValue((prev) => ({ ...prev, status_ids }))
            }
            options={statusesOptions}
          />
          <div className="my-2" />
          <div
            style={{
              height: 38,
            }}
          >
            <ButtonSecondary
              disabled={mutationCreate.isLoading}
              onClick={() => {
                setErrors({});

                if (!value.title) {
                  antdMessageError();
                  return setErrors({ title: "Cant be empty" });
                }
                mutationCreate.mutate(value);
              }}
            >
              {!!value?.id ? "Update" : "Create"}
            </ButtonSecondary>
          </div>
          <br />
        </div>
      )}
    </ModalSimple>
  );
};

export default ModalUserRoleCreate;

const PermissionBlock = ({
  title,
  uuid,
  parent_uuid,
  options,
  setOpen,
  Open,
  setPermissions,
  permissions,
  padding_left = 0,
}) => {
  const shrinkClick = () => {
    setOpen((prev) => {
      if (prev.includes(title)) {
        return prev.filter((e) => e !== title);
      } else {
        return [...prev, title];
      }
    });
  };

  const its_openned = Open.includes(title);
  const mainActive = !!permissions[uuid] && padding_left == 0;
  return (
    <>
      <ApplyActionItemStyled
        active={its_openned && mainActive}
        className={`${padding_left ? "children" : "font-weight-bold"} ${
          mainActive ? "active" : ""
        }`}
      >
        <div
          className="d-flex align-items-center justify-content-between"
          style={{
            padding: `12px 10px 12px ${padding_left + 12}px`,
          }}
        >
          <CheckBoxInput
            text={title}
            checked={permissions[uuid] || false}
            onChange={() =>
              setPermissions(
                [uuid, parent_uuid],
                options?.filter((e) => !e?.options).map((e) => e.uuid)
              )
            }
          />
          {options && options.length > 0 && (
            <div className="ml-auto">
              {its_openned ? (
                <IconChevronUp
                  color="#5F5F5F"
                  className="cursor-pointer ml-2"
                  onClick={() => shrinkClick()}
                />
              ) : (
                <IconChevronDown
                  color="#5F5F5F"
                  className="cursor-pointer ml-2"
                  onClick={() => shrinkClick()}
                />
              )}
            </div>
          )}
        </div>
        {its_openned && options && options.length > 0 && (
          <div className="block-header">
            {options?.map((d) => (
              <PermissionBlock
                key={d.uuid}
                parent_uuid={uuid}
                {...d}
                setOpen={setOpen}
                Open={Open}
                setPermissions={setPermissions}
                permissions={permissions}
                padding_left={padding_left + 4}
              />
            ))}
          </div>
        )}
      </ApplyActionItemStyled>
    </>
  );
};

const ApplyActionItemStyled = styled.div`
  & .checkbox_text {
    color: #6c6c6c;
    font-weight: 500;
  }
  &.active .checkbox_text {
    color: #03b0f7;
  }
  :not(.children) {
    background: ${(props) => (props.active ? "#EDF9FE" : "#FCFCFC")};
    border: 1px solid ${(props) => (props.active ? "#03B0F7" : "#d9d9d9")};
    margin-bottom: 5px;
    border-radius: 4px;
  }
  .block-header {
    border-top: 1px solid
      ${(props) => (props.active ? colors["primary"] : colors["grey"])};
    background: silver;
    border-radius: 4px 4px 0px 0px;
    & .children:nth-child(odd) {
      background-color: #f5fcff;
    }

    & .children:nth-child(even) {
      background-color: #ebf9fe;
    }
    & .children:last-child {
      border-radius: 0px 0px 4px 4px;
    }
    .checkbox_text {
      color: #6c6c6c;
    }
  }
`;
